import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage } from './pages/Login';
import { LandingPage } from './pages/Landing';
import { HomePage } from './pages/Home';
import { ResultPage } from './pages/Result';
import { HistoryPage } from './pages/History';
import { AdminPage } from './pages/Admin';
import { getUser } from './lib/api';

function RequireUser({ children }: { children: React.ReactNode }) {
  const u = getUser();
  if (!u) return <Navigate to="/login" replace />;
  if (u.role === 'admin') return <Navigate to="/admin" replace />;
  return <>{children}</>;
}

function RequireAdmin({ children }: { children: React.ReactNode }) {
  const u = getUser();
  if (!u) return <Navigate to="/login" replace />;
  if (u.role !== 'admin') return <Navigate to="/app" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/app"
          element={
            <RequireUser>
              <HomePage />
            </RequireUser>
          }
        />
        <Route
          path="/result/:id"
          element={
            <RequireUser>
              <ResultPage />
            </RequireUser>
          }
        />
        <Route
          path="/history"
          element={
            <RequireUser>
              <HistoryPage />
            </RequireUser>
          }
        />
        <Route
          path="/admin"
          element={
            <RequireAdmin>
              <AdminPage />
            </RequireAdmin>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
